import { ReduxState } from 'src/store/types';

export const querylogDatabaseSelector = (state: ReduxState) => {
  const connectionId = state.connections.connection?.id;
  const { querylogDatabaseByConnectionId } = state.connections;
  return querylogDatabaseByConnectionId[connectionId || ''] || 'querylog';
};
